export const API_PATH = {
  getList: '/getAllCat.php',
  getDetail: '/getCatInfo.php',
  getCategory: '/getCatType.php',
} as const;
